import React from 'react'

const Avocado = ({color = '#009341'}) => {

    return (
        <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
            <clipPath id="clip0_202_4259">
            <rect width="62.81" height="93.85" fill="white" transform="translate(44 28)"/>
            </clipPath>
            </defs>
            <g clip-path="url(#clip0_202_4259)">
            <path d="M44.0299 87.53C43.6399 80.78 47.0899 73.7 52.7999 67.65C58.8087 61.3614 63.1742 53.6883 65.5099 45.31C66.0206 43.0865 66.8706 40.9549 68.0299 38.99C69.9457 35.8269 72.2764 32.9345 74.9599 30.39C78.3999 27.39 82.5899 27.39 86.7799 29.39C96.4899 34.13 101.08 42.25 99.7799 52.96C98.8157 59.9374 99.7591 67.0457 102.51 73.53C104.79 78.89 106.94 84.3 106.8 90.32C106.5 103.61 100.66 113.55 88.4299 118.91C76.0499 124.33 64.4299 122.05 54.3299 113.14C47.2399 106.9 44.0399 98.76 44.0299 87.53ZM93.5499 91.61C93.5257 88.5069 92.8816 85.4399 91.6555 82.5893C90.4294 79.7386 88.6459 77.1617 86.4099 75.01C79.7699 68.69 71.1599 69.01 65.2999 76.1C60.6107 81.6637 58.171 88.7795 58.4599 96.05C58.451 98.9939 59.3658 101.867 61.0754 104.263C62.785 106.66 65.2034 108.46 67.9899 109.41C78.1599 112.83 93.6399 105.89 93.5499 91.6V91.61Z" fill={color}/>
            </g>
            
        </svg>
    )
}

export default Avocado